import React from "react";
import { useNavigate } from "react-router-dom";
import { HiVideoCamera, HiOfficeBuilding, HiArrowRight } from "react-icons/hi";
import Header from "../components/Header";
import Footer from "../components/Footer";

/**
 * Doctor Appointment entry page (referencing dashboard appointment flow).
 * Choose appointment type: Video Consulting (doctor's available times/shifts)
 * or Hospital Appointment (pick hospital then doctor with correct time/shift).
 * Time slots respect doctor availability; past times are not allowed.
 */
const Appointment = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <Header
        onAppointmentClick={() => navigate("/appointment")}
        onNurseAppointmentClick={() => navigate("/nurses-list")}
        onApplyNurseClick={() => {}}
        onApplyDoctorClick={() => {}}
      />

      <div className="pt-24 pb-16 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-3xl md:text-4xl font-black text-gray-900 mb-2">
              Book a Doctor Appointment
            </h1>
            <p className="text-gray-500">
              Choose how you’d like to see a doctor. Times and shifts follow each doctor’s availability; past times cannot be booked.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Video Consulting */}
            <button
              type="button"
              onClick={() => navigate("/doctors")}
              className="group flex flex-col items-start text-left p-8 rounded-3xl bg-white border-2 border-gray-100 hover:border-blue-500 hover:shadow-xl transition-all shadow-lg"
            >
              <div className="w-14 h-14 rounded-2xl bg-blue-100 flex items-center justify-center mb-6 group-hover:bg-blue-200 transition-colors">
                <HiVideoCamera className="w-7 h-7 text-blue-600" />
              </div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">
                Video Consulting
              </h2>
              <p className="text-gray-500 text-sm mb-6 flex-1">
                Book an online video call with a doctor. You’ll see only available dates, shifts, and times; past slots are hidden.
              </p>
              <span className="inline-flex items-center gap-2 text-blue-600 font-semibold text-sm">
                Choose a doctor <HiArrowRight className="w-4 h-4" />
              </span>
            </button>

            {/* Hospital Appointment */}
            <button
              type="button"
              onClick={() => navigate("/hospitals")}
              className="group flex flex-col items-start text-left p-8 rounded-3xl bg-white border-2 border-gray-100 hover:border-blue-500 hover:shadow-xl transition-all shadow-lg"
            >
              <div className="w-14 h-14 rounded-2xl bg-green-100 flex items-center justify-center mb-6 group-hover:bg-green-200 transition-colors">
                <HiOfficeBuilding className="w-7 h-7 text-green-600" />
              </div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">
                Hospital Appointment
              </h2>
              <p className="text-gray-500 text-sm mb-6 flex-1">
                Visit a hospital in person. Pick a hospital, then a doctor. Available times and shifts follow the doctor’s schedule; finished times cannot be selected.
              </p>
              <span className="inline-flex items-center gap-2 text-green-600 font-semibold text-sm">
                Choose a hospital <HiArrowRight className="w-4 h-4" />
              </span>
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Appointment;
